<app-loader></app-loader>

<div class="layout-container" [ngClass]="containerClass">
   <app-sidebar></app-sidebar>
   <div class="layout-content-wrapper">
      <app-topbar></app-topbar>
      <div class="layout-content">
         <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
         <router-outlet></router-outlet>
      </div>
   </div>
   <app-profilemenu></app-profilemenu>
   <p-scrollTop [threshold]="500"></p-scrollTop>
   <app-nuria-chat *ngIf="isSuperAdmin"></app-nuria-chat>
</div>

<app-announcement-banner></app-announcement-banner>
